import {Evaluation} from "../../assets/js/evaluation";
import {numberAddUnit, twodecimal} from "../../assets/js/utils";

var data = [
    [
        // [
        //     7062, //横轴坐标
        //     75.4, //y轴坐标
        //     25211, // 散点度
        //     'United States', //
        //     '优质' // 数据类目
        // ]
    ],
    [],
    [],
    [],

];

export const NewScatterOption = function () {
    return {
        backgroundColor: 'white',
        legend: {   top: 0, left: '4%',    textStyle: {color: '#999999'},   itemHeight: 6,     itemWidth: 10,   },
        tooltip: {
            trigger: 'axis', padding: 8,
            // axis: 'y',
            triggerOn: 'none',
            axisPointer: {
                status: 'hide',
                label: {show: false},
                type: 'cross',  lineStyle: {color: '#333', type: "solid"},  crossStyle: {color: '#333', type: "solid"} },
            backgroundColor: '#ffff',   textStyle: {    color: "#333333" },
            formatter: function (params) {
                let data ={};
                if(params[0] && params[0].data){
                    data = params[0].data;
                }

                return `${data.secSname} &nbsp;${data.secCode}
                        <br>财务：${twodecimal(data.score)}分 ${data.evaluation}
                        <br>市值：${numberAddUnit(data.indexValue)}  
                        `
            }
        },
        grid: {
            "left": "4%", "top": "40", "bottom": "0", containLabel: true
        },
        xAxis: {
            axisTick: false, // 是否显示刻度

            axisLabel: {
                formatter: function (value) {
                    return value / 10000 / 10000 + "亿";
                }, color: '#999999', fontSize: 10
            },
            splitLine: { //分割线
                show: false, lineStyle: {type: 'dashed'}
            },
            axisLine: {
                lineStyle: {
                    color: '#EEEEEE' // 坐标轴颜色
                }
            }
        },
        yAxis: {
            axisTick: false, axisLabel: {formatter: '{value}分', color: '#999999', fontSize: 10},
            splitLine: {show: false, lineStyle: {type: 'dashed'}},
            axisLine: {
                lineStyle: {
                    color: '#EEEEEE' // 坐标轴颜色
                }
            }, scale: true
        },
        series: [
            {
                name: Evaluation.normal, data: data[0], type: 'scatter',
                symbolSize: function (data) {
                    return data[2];
                }, itemStyle: {color: 'rgba(47,194,132,0.5)'}
            },
            // {
            //     name: '健康', data: data[1], type: 'scatter',
            //     symbolSize: function (data) {
            //         return data[2];
            //     }, itemStyle: {color: 'rgba(17,148,183,0.5)'}
            // },
            {
                name: Evaluation.subhealth, data: data[2], type: 'scatter',
                symbolSize: function (data) {
                    return data[2];
                }, itemStyle: {color: 'rgba(224,193,71,0.5)'}
            },
            {
                name: Evaluation.risk, data: data[3], type: 'scatter',
                symbolSize: function (data) {
                    return data[2];
                }, itemStyle: {color: 'rgba(242,42,42,0.5)'}
            }
        ]
    };
}
